import MacOsFrame from "./MacOs";
import environment from "src/utils/environment";
import { Box, useColorModeValue } from "@chakra-ui/react";

export default function Frame({ ...props }) {
  const borderColor = useColorModeValue("rgba(0, 0, 0, 0.08)", "black");
  if (environment.isMacOs) {
    return <MacOsFrame {...props} />;
  } else {
    return (
      <>
        <Box
          pos="fixed"
          zIndex={101}
          top={0}
          left={0}
          width="100vw"
          border="1px solid"
          borderColor={borderColor}
        />
        {props.children}
      </>
    );
  }
}
